import { useCallback } from 'react';
import permissionService from '../services/permissionService';

// Hook global para refrescar permisos
export const usePermissionRefresh = () => {
  console.log('🔧 usePermissionRefresh hook montado');
  
  // Función para refrescar permisos después del login
  const refreshPermissionsAfterLogin = useCallback(async () => {
    console.log('🔐 Hook: Iniciando refresh de permisos después del login...');
    
    try {
      // Usar el servicio para refrescar permisos
      const updatedPermissions = await permissionService.refreshAfterLogin();
      
      // Disparar evento personalizado para notificar a todos los componentes
      window.dispatchEvent(new CustomEvent('permissionsRefreshed', {
        detail: {
          permissions: updatedPermissions,
          timestamp: new Date().toISOString(),
          trigger: 'login'
        }
      }));
      
      console.log('✅ Hook: Permisos refrescados y evento disparado');
      return updatedPermissions;
      
    } catch (error) {
      console.error('❌ Hook: Error refrescando permisos:', error);
      throw error;
    }
  }, []);

  console.log('🔧 usePermissionRefresh retornando:', { refreshPermissionsAfterLogin });
  
  return {
    refreshPermissionsAfterLogin
  };
};

export default usePermissionRefresh;
